export const headerSettings = [
  {
    key: "caName",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 250,
    value: "CA Name",
    align: "center",
  },
  {
    key: "caSummary",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 200,
    value: "CA Summary",
    align: "center",
  },
  {
    key: "allowanceType",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 120,
    value: "Allowance Type",
    align: "center",
  },
  {
    key: "initialAllowanceRate",
    visibility: ["S16"],
    width: 120,
    value: "IA Rate (%)",
    align: "center",
  },
  {
    key: "noOfYearClaims",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 120,
    value: "No. of years of claim",
    align: "center",
  },
  {
    key: "noOfYearClaimsBf",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 120,
    value: "No. of years b/f",
    align: "center",
  },
  {
    key: "principalPaid",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "Principal Paid",
    align: "right",
  },
  {
    key: "cost",
    visibility: ["S19D"],
    width: 150,
    value: "Cost",
    align: "right",
  },
  {
    key: "assetInUseAtFYE",
    visibility: ["S19D"],
    width: 150,
    value: "Asset in use at FYE",
    align: "center",
  },
  {
    key: "twdvBf",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "TWDV b/f",
    align: "right",
  },
  {
    key: "currentAmount",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "Additions",
    align: "right",
  },
  {
    key: "currentAmount",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "Prior Year Disposal",
    align: "right",
  },
  {
    key: "currentYearDisposal",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "Current Year Disposal",
    align: "right",
  },
  {
    key: "totalAmount",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "Total",
    align: "right",
  },
  {
    key: "isDeferred",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 80,
    value: "Deferred",
    align: "center",
  },
  {
    key: "isDisregard",
    visibility: ["S16"],
    width: 80,
    value: "Disregard",
    align: "center",
  },
  {
    key: "disregardRate",
    visibility: ["S16"],
    width: 90,
    value: "Disregard Rate (%)",
    align: "center",
  },
  {
    key: "initialAllowance",
    visibility: ["S19", "S16"],
    width: 180,
    value: "Initial Allowance (IA)",
    align: "right",
    showInHirePurchase: false,
  },
  {
    key: "annualAllowance",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 180,
    value: "Annual Allowance (AA)",
    align: "right",
  },
  {
    key: "twdvCf",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "TWDV c/f",
    align: "right",
  },
  {
    key: "initialAllowance",
    visibility: ["S19"],
    width: 180,
    value: "Initial Allowance (IA)",
    align: "right",
    showInHirePurchase: true,
  },
  {
    key: "noOfYearClaimsCf",
    visibility: ["S19A", "S19", "S19B", "S19D", "S16"],
    width: 150,
    value: "No. of years c/f",
    align: "center",
  },
];

export const columnSettings = {
  caName: { type: "caName", align: "center" },
  caSummary: { type: "caSummary", align: "center" },
  cost: { type: "numeric", align: "right" },
  allowanceType: { type: "allowanceType", align: "center" },
  initialAllowanceRate: { type: "initialAllowanceRate", align: "center" },
  s16Type: { type: "s16Type", align: "center" },
  noOfYearClaims: { type: "noOfYearClaims", align: "center" },
  noOfYearClaimsBf: { type: "string", align: "center" },
  principalPaid: { type: "numeric", align: "right" },
  twdvBf: { type: "numeric", align: "right" },
  currentAmount: { type: "currentAmount", align: "right" },
  currentYearDisposal: { type: "numeric", align: "right" },
  totalAmount: { type: "numeric", align: "right" },
  isDeferred: { type: "bool", align: "center" },
  isDisregard: { type: "isDisregard", align: "center" },
  disregardRate: { type: "disregardRate", align: "center" },
  initialAllowance: { type: "numeric", align: "right" },
  annualAllowance: { type: "numeric", align: "right" },
  assetInUseAtFYE: { type: "assetInUseAtFYE", align: "center" },
  twdvCf: { type: "numeric", align: "right" },
  noOfYearClaimsCf: { type: "string", align: "center" },
};
